import './animations/keyframes/global.css';
import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import { cssTransition, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadMask from './components/LoadMask';

import PrivateRoute from './components/PrivateRoute';
import { initGA } from './components/Tracking';
import { PAGE_TITLE } from './constants/page-title';
import { PERMISSIONS } from './constants/permissions';
import { ROLES } from './constants/roles';
import { ROUTE, ROUTE_REGEXP } from './constants/route';
import AppLayout from './layouts/AppLayout';
import Account from './pages/Account';
import AddRecommendation from './pages/AddRecommendation';
import AddReview from './pages/AddReview';
import Aptitude from './pages/Aptitude';
import AptitudeTest from './pages/AptitudeTest';
import Calendar from './pages/Calendar';
import CandidateAccountRegistration from './pages/CandidateAccountRegistration';
import CandidateProfile from './pages/CandidateProfile';
import CandidateProfileEditor from './pages/CandidateProfileEditor';
import CandidateProfileOwn from './pages/CandidateProfileOwn';
import Checkout from './pages/Checkout';
import ConfidentialInformation from './pages/ConfidentialInformation';
import CreateUpdateEmailTemplateFollowup from './pages/CreateUpdateEmailTemplateFollowup';
import CreateUpdateProcess from './pages/CreateUpdateProcess';

import Firm from './pages/Firm';
import GlobalSearch from './pages/GlobalSearch';
import Home from './pages/Home';
import InBounds from './pages/InBounds';
import InBoundsRequirements from './pages/InBoundsRequirements';
import Inbox from './pages/Inbox';
import Job from './pages/Job';
import JobProfile from './pages/JobProfile';
import Jobs from './pages/Jobs';
import ManageEmailsTemplates from './pages/ManageEmailsTemplates';
import ManageProcess from './pages/ManageProcess';
import MyNetwork from './pages/MyNetwork';
import MyTeam from './pages/MyTeam';
import Network from './pages/Network';
import NotFoundPage from './pages/NotFoundPage';
import PeopleYouMayKnow from './pages/PeopleYouMayKnow';
import Preparatory from './pages/Preparatory';
import PublicProcessProfile from './pages/PublicProcessProfile';
import PurchaseCandidate from './pages/PurchaseCandidate';
import PurchaseRecruiter from './pages/PurchaseRecruiter';
import RatedCandidates from './pages/RatedCandidates';
import RecruiterProcessSurvey from './pages/RecruiterProcessSurvey';
import Review from './pages/Review';
import Reviews from './pages/Reviews';
import Search from './pages/Search';
import SetupEmail from './pages/SetupEmail';
import Shortlist from './pages/Shortlist';
import ShortlistProfessionals from './pages/ShortlistProfessionals';
import SignupPage from './pages/Signup';
import SubscriptionSearches from './pages/SubscriptionSearches';
import ViewApplicants from './pages/ViewApplicants';

import ActionTypes from './redux/actions/action-types';
import './App.css';
import { readOptions } from './redux/actions/core';
import { User } from './redux/actions/user';

const Fade = cssTransition({
  enter: `Toastify--animate Toastify__fade-enter`,
  exit: `Toastify--animate Toastify__fade-exit`,
  appendPosition: false,
});

class App extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      isUserDataInit: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;

    if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
      initGA(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
    }

    this.props.onReadOptions();
    this.props.loadUserState().then(() => {
      if (this._isMounted) {
        this.setState({
          isUserDataInit: true,
        });
      }
    });
  }

  // refresh page after sign-in
  shouldComponentUpdate(nextProps) {
    if (
      this.state.isUserDataInit &&
      nextProps.user.isLoggedIn &&
      !this.props.user.isLoggedIn
    ) {
      window.location = ROUTE.HOME;
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      loader,
      user,
      options,
      loadUserState,
      updateUserPicture,
      updateUserResume,
      updateInboxCount,
      updateUserPopups,
      updateUserInboundsCount,
      updateUserPermission,
      updateUserOption,
      loaderShow,
      loaderHide,
      setHeaderTitle,
    } = this.props;
    const { isUserDataInit } = this.state;
    const actions = {
      loaderShow,
      loaderHide,
      setHeaderTitle,
      loadUserState,
      updateUserPicture,
      updateUserResume,
      updateInboxCount,
      updateUserPopups,
      updateUserInboundsCount,
      updateUserPermission,
      updateUserOption,
    };

    return (
      isUserDataInit && (
        <AppLayout user={user} header={this.props.header}>
          <Switch>
            <Route
              exact
              path={ROUTE_REGEXP.PROCESS_PUBLIC}
              render={props => (
                <PublicProcessProfile
                  {...props}
                  user={user}
                  globalOptions={options}
                  globalActions={actions}
                />
              )}
            />
            <Route
              exact
              path={ROUTE_REGEXP.FIRM_REVIEW}
              render={() => (
                <Review
                  user={user}
                  globalOptions={options}
                  globalActions={actions}
                />
              )}
            />
            <Route
              exact
              sensitive
              strict
              path={[
                ROUTE_REGEXP.FIRM_TAB,
                ROUTE_REGEXP.FIRM_REVIEW_FORM,
                ROUTE_REGEXP.FIRM_PROFILE,
              ]}
              render={() => (
                <Firm
                  user={user}
                  globalOptions={options}
                  globalActions={actions}
                />
              )}
            />
            <Route
              exact
              sensitive
              strict
              path={ROUTE.ADD_RECOMMENDATION}
              render={props => (
                <AddRecommendation
                  {...props}
                  user={user}
                  globalOptions={options}
                  globalActions={actions}
                />
              )}
            />
            <Route
              sensitive
              path={ROUTE.SIGNUP}
              render={props => (
                <SignupPage
                  {...props}
                  user={user}
                  globalOptions={options}
                  globalActions={actions}
                />
              )}
            />
            {/*{!user.isLoggedIn && (*/}
            {/*  <Route*/}
            {/*    exact*/}
            {/*    sensitive*/}
            {/*    strict*/}
            {/*    path={[ROUTE_REGEXP.STUDENT, ROUTE_REGEXP.STUDENT_HELLO]}*/}
            {/*    render={props => (*/}
            {/*      <StudentPage*/}
            {/*        {...props}*/}
            {/*        user={user}*/}
            {/*        globalOptions={options}*/}
            {/*        globalActions={actions}*/}
            {/*      />*/}
            {/*    )}*/}
            {/*  />*/}
            {/*)}*/}
            <PrivateRoute
              path={[ROUTE_REGEXP.HOME_NEWS, ROUTE.HOME]}
              exact
              sensitive
              strict
              pageTitle={PAGE_TITLE.HOME}
              component={Home}
              user={user}
              role={[ROLES.CANDIDATE, ROLES.RECRUITER, ROLES.PENDING_CANDIDATE]}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              path={ROUTE.REVIEWS}
              exact
              sensitive
              strict
              pageTitle={PAGE_TITLE.REVIEWS}
              component={Reviews}
              user={user}
              role={[ROLES.CANDIDATE, ROLES.RECRUITER, ROLES.PENDING_CANDIDATE]}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              path={ROUTE_REGEXP.REVIEWS_ACTIONS}
              exact
              sensitive
              strict
              pageTitle={PAGE_TITLE.ADD_REVIEW}
              component={AddReview}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              path={ROUTE.PEOPLE_YOU_MAY_KNOW}
              pageTitle={PAGE_TITLE.PEOPLE_YOU_MAY_KNOW}
              component={PeopleYouMayKnow}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              path={ROUTE.NETWORK}
              pageTitle={PAGE_TITLE.NETWORK}
              component={Network}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              path={ROUTE.MY_NETWORK}
              pageTitle={PAGE_TITLE.MY_NETWORK}
              component={MyNetwork}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.JOBS}
              pageTitle={PAGE_TITLE.JOBS}
              component={Jobs}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.JOB}
              component={Job}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            {/*<PrivateRoute*/}
            {/*  exact*/}
            {/*  sensitive*/}
            {/*  strict*/}
            {/*  path={ROUTE.PROJECTS}*/}
            {/*  pageTitle={PAGE_TITLE.PROJECTS}*/}
            {/*  component={Projects}*/}
            {/*  user={user}*/}
            {/*  role={ROLES.CANDIDATE}*/}
            {/*  globalOptions={options}*/}
            {/*  globalActions={actions}*/}
            {/*/>*/}
            {/*<PrivateRoute*/}
            {/*  path={ROUTE_REGEXP.PROJECT}*/}
            {/*  exact*/}
            {/*  sensitive*/}
            {/*  strict*/}
            {/*  component={Project}*/}
            {/*  user={user}*/}
            {/*  role={ROLES.CANDIDATE}*/}
            {/*  globalOptions={options}*/}
            {/*  globalActions={actions}*/}
            {/*/>*/}
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.SEARCH}
              pageTitle={PAGE_TITLE.SEARCH}
              component={Search}
              user={user}
              role={ROLES.RECRUITER}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.SEARCH_RATED}
              pageTitle={PAGE_TITLE.SEARCH_RATED}
              component={RatedCandidates}
              user={user}
              role={ROLES.RECRUITER}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={[
                ROUTE.SEARCH_PROCESS_MANAGE,
                ROUTE_REGEXP.SEARCH_PROCESS_MANAGE,
              ]}
              pageTitle={PAGE_TITLE.SEARCH_PROCESS_MANAGE}
              component={ManageProcess}
              user={user}
              role={ROLES.RECRUITER}
              permission={PERMISSIONS.MANAGE_JOBS}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.SEARCH_JOB_PROFILE}
              component={JobProfile}
              user={user}
              role={ROLES.RECRUITER}
              permission={PERMISSIONS.MANAGE_JOBS}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.SEARCH_PROCESS_ACTIONS}
              component={CreateUpdateProcess}
              user={user}
              role={ROLES.RECRUITER}
              permission={PERMISSIONS.MANAGE_JOBS}
              globalOptions={options}
              globalActions={actions}
            />
            {/*<PrivateRoute*/}
            {/*  exact*/}
            {/*  sensitive*/}
            {/*  strict*/}
            {/*  path={[*/}
            {/*    ROUTE.SEARCH_PROJECT_MANAGE,*/}
            {/*    ROUTE_REGEXP.SEARCH_PROJECT_MANAGE,*/}
            {/*  ]}*/}
            {/*  pageTitle={PAGE_TITLE.SEARCH_PROJECT_MANAGE}*/}
            {/*  component={ManageProject}*/}
            {/*  user={user}*/}
            {/*  role={ROLES.RECRUITER}*/}
            {/*  permission={PERMISSIONS.MANAGE_PROJECTS}*/}
            {/*  globalOptions={options}*/}
            {/*  globalActions={actions}*/}
            {/*/>*/}
            {/*<PrivateRoute*/}
            {/*  exact*/}
            {/*  sensitive*/}
            {/*  strict*/}
            {/*  path={ROUTE_REGEXP.SEARCH_PROJECT_PROFILE}*/}
            {/*  component={ProjectProfile}*/}
            {/*  user={user}*/}
            {/*  role={ROLES.RECRUITER}*/}
            {/*  permission={PERMISSIONS.MANAGE_PROJECTS}*/}
            {/*  globalOptions={options}*/}
            {/*  globalActions={actions}*/}
            {/*/>*/}
            {/*<PrivateRoute*/}
            {/*  exact*/}
            {/*  sensitive*/}
            {/*  strict*/}
            {/*  path={ROUTE_REGEXP.SEARCH_PROJECT_ACTIONS}*/}
            {/*  component={CreateUpdateProject}*/}
            {/*  user={user}*/}
            {/*  role={ROLES.RECRUITER}*/}
            {/*  permission={PERMISSIONS.MANAGE_PROJECTS}*/}
            {/*  globalOptions={options}*/}
            {/*  globalActions={actions}*/}
            {/*/>*/}
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.SEARCH_VIEW_APPLICANTS}
              component={ViewApplicants}
              user={user}
              role={ROLES.RECRUITER}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.SEARCH_SUBSCRIPTION}
              pageTitle={PAGE_TITLE.SEARCH_SUBSCRIPTION}
              component={SubscriptionSearches}
              user={user}
              role={ROLES.RECRUITER_GBS}
              permission={PERMISSIONS.SUBSCRIPTION_SEARCHES}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.SEARCH_SUBSCRIPTION_EDIT}
              component={CreateUpdateProcess}
              user={user}
              role={ROLES.RECRUITER_PREMIUM_REC_FIRM}
              permission={PERMISSIONS.SUBSCRIPTION_SEARCHES}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.SEARCH_SUBSCRIPTION_PROFILE}
              component={JobProfile}
              user={user}
              role={ROLES.RECRUITER_PREMIUM_REC_FIRM}
              permission={PERMISSIONS.SUBSCRIPTION_SEARCHES}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.SEARCH_INBOUNDS}
              pageTitle={PAGE_TITLE.SEARCH_INBOUNDS}
              component={InBounds}
              user={user}
              role={ROLES.RECRUITER}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.SEARCH_INBOUNDS_REQUIREMENTS}
              pageTitle={PAGE_TITLE.SEARCH_INBOUNDS_REQUIREMENTS}
              component={InBoundsRequirements}
              user={user}
              role={ROLES.RECRUITER}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={[
                ROUTE_REGEXP.SEARCH_SHORTLIST_SHARE,
                ROUTE.SEARCH_SHORTLIST,
              ]}
              pageTitle={PAGE_TITLE.SEARCH_SHORTLIST}
              component={Shortlist}
              user={user}
              role={ROLES.RECRUITER}
              permission={PERMISSIONS.CANDIDATES_SHORTLISTS}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.SEARCH_SHORTLIST}
              pageTitle={PAGE_TITLE.SHORTLIST_PROFESSIONALS}
              component={ShortlistProfessionals}
              user={user}
              role={ROLES.RECRUITER}
              permission={PERMISSIONS.CANDIDATES_SHORTLISTS}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.SEARCH_EMAILS_TEMPLATES}
              pageTitle={PAGE_TITLE.MANAGE_EMAILS_TEMPLATES}
              component={ManageEmailsTemplates}
              user={user}
              role={ROLES.RECRUITER}
              permission={PERMISSIONS.USE_EMAIL_TEMPLATE_FOLLOWUP}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={[
                ROUTE_REGEXP.SEARCH_EMAILS_TEMPLATES_CREATE,
                ROUTE_REGEXP.SEARCH_EMAILS_TEMPLATES_EDIT,
              ]}
              pageTitle={PAGE_TITLE.MANAGE_EMAILS_TEMPLATES}
              component={CreateUpdateEmailTemplateFollowup}
              user={user}
              role={ROLES.RECRUITER}
              permission={PERMISSIONS.USE_EMAIL_TEMPLATE_FOLLOWUP}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.SEARCH_TEAM}
              pageTitle={PAGE_TITLE.SEARCH_TEAM}
              component={MyTeam}
              user={user}
              role={ROLES.RECRUITER}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.CANDIDATE_ACCOUNT_REGISTRATION}
              pageTitle={PAGE_TITLE.CANDIDATE_ACCOUNT_REGISTRATION}
              component={CandidateAccountRegistration}
              user={user}
              permission={PERMISSIONS.CREATE_CANDIDATE_ACCOUNT}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.INBOX}
              pageTitle={PAGE_TITLE.INBOX}
              component={Inbox}
              user={user}
              role={[ROLES.CANDIDATE, ROLES.RECRUITER, ROLES.PENDING_CANDIDATE]}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.CANDIDATE_PROFILE}
              component={CandidateProfile}
              user={user}
              role={[ROLES.CANDIDATE, ROLES.RECRUITER]}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.CANDIDATE_PROFILE}
              pageTitle={PAGE_TITLE.CANDIDATE_PROFILE}
              component={CandidateProfileOwn}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.CANDIDATE_PROFILE_EDITOR}
              pageTitle={PAGE_TITLE.CANDIDATE_PROFILE}
              component={CandidateProfileEditor}
              user={user}
              role={ROLES.RECRUITER_GBS}
              permission={PERMISSIONS.EDIT_CANDIDATE_PROFILE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              pageTitle={PAGE_TITLE.CANDIDATE_ACCOUNT}
              path={ROUTE.CANDIDATE_ACCOUNT}
              component={Account}
              user={user}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.CANDIDATE_CONFIDENTIAL}
              pageTitle={PAGE_TITLE.CANDIDATE_CONFIDENTIAL}
              component={ConfidentialInformation}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.CANDIDATE_APTITUDE}
              pageTitle={PAGE_TITLE.CANDIDATE_APTITUDE}
              component={Aptitude}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.CANDIDATE_PREPARATORY}
              pageTitle={PAGE_TITLE.CANDIDATE_PREPARATORY}
              component={Preparatory}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.CANDIDATE_UPGRADE_PREMIUM}
              pageTitle={PAGE_TITLE.CANDIDATE_UPGRADE_PREMIUM}
              component={PurchaseCandidate}
              user={user}
              role={ROLES.CANDIDATE}
              permission={PERMISSIONS.VIEW_PRICE_CANDIDATE_PREMIUM}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.RECRUITER_MANAGE_CALENDAR}
              pageTitle={PAGE_TITLE.RECRUITER_MANAGE_CALENDAR}
              component={Calendar}
              user={user}
              role={ROLES.RECRUITER_GBS}
              permission={PERMISSIONS.PERSONAL_CALENDAR}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.CHECKOUT_RECRUITER}
              component={Checkout}
              user={user}
              role={ROLES.RECRUITER_RESTRICTED}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE_REGEXP.CHECKOUT_CANDIDATE}
              component={Checkout}
              user={user}
              role={ROLES.CANDIDATE}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.RECRUITER_PURCHASE}
              pageTitle={PAGE_TITLE.RECRUITER_PURCHASE}
              component={PurchaseRecruiter}
              user={user}
              role={ROLES.RECRUITER_RESTRICTED}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.CANDIDATE_APTITUDE_TEST}
              component={AptitudeTest}
              user={user}
              role={ROLES.CANDIDATE}
              permission={PERMISSIONS.RUN_APTITUDE_TEST}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              path={ROUTE.GLOBAL_SEARCH}
              component={GlobalSearch}
              user={user}
              globalOptions={options}
              globalActions={actions}
            />
            <PrivateRoute
              exact
              sensitive
              strict
              pageTitle="Setup Email Template"
              path={ROUTE_REGEXP.SEARCH_PROCESS_SETUP_EMAIL}
              component={SetupEmail}
              user={user}
              role={ROLES.RECRUITER}
              permission={PERMISSIONS.USE_PROCESS_SETUP_EMAIL}
              globalOptions={options}
              globalActions={actions}
            />
            <Route
              exact
              sensitive
              strict
              pageTitle="Survey"
              path={ROUTE.SURVEY}
              render={props => (
                <RecruiterProcessSurvey
                  {...props}
                  user={user}
                  globalOptions={options}
                  globalActions={actions}
                />
              )}
            />
            <Route render={props => <NotFoundPage user={user} {...props} />} />
          </Switch>
          {loader ? <LoadMask /> : null}
          <ToastContainer
            transition={Fade}
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            theme="light"
          />
        </AppLayout>
      )
    );
  }
}

const mapStateToProps = state => ({
  loader: state.core.loader,
  user: state.core.user,
  options: state.core.options,
  header: state.core.header,
});

const mapDispatchToProps = dispatch => ({
  loaderShow: () => dispatch({ type: ActionTypes.LOADER_SHOW }),
  loaderHide: () => dispatch({ type: ActionTypes.LOADER_HIDE }),
  setHeaderTitle: title => dispatch({ type: ActionTypes.SET_HEADER_TITLE, payload: title }),
  loadUserState: () => dispatch(User.get()),
  updateInboxCount: count => dispatch(User.updateInboxCount(count)),
  updateUserInboundsCount: count => dispatch(User.updateInboundsCount(count)),
  updateUserPicture: picture => dispatch(User.updatePicture(picture)),
  updateUserResume: () => dispatch(User.uploadResume()),
  updateUserPopups: popups => dispatch(User.uploadPopups(popups)),
  updateUserPermission: (permission, value) =>
    dispatch(User.updateUserPermission(permission, value)),
  updateUserOption: (option, value) =>
    dispatch(User.updateUserOption(option, value)),
  onReadOptions: () => dispatch(readOptions()),
});

export default hot(module)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);
